import {
  AuthSaga,
  ExperimentsSaga,
  FirebaseSaga,
  LanguageSaga,
  NotificationSaga,
  SentryService,
  StatsSaga,
  parseError,
} from '@web_opxp/features';
import { Lottie } from '@web_opxp/lottie';
import { Dispatch } from 'redux';
import { all, call, put, spawn } from 'redux-saga/effects';
import { NetworkError, RequestAbortedError, SharedErrors } from 'web_core_library';
import { AppSaga } from '../app';
import { CheckoutSaga } from '../checkout';
import { CouponSaga } from '../coupon';
import { ManageAppSaga } from '../manage';
import { OrdersAppSaga } from '../orders';
import { SubscribeSaga } from '../subscribe';

export function* handleErrorSaga(error: SharedErrors.BaseError | Error) {
  console.error(error.message);
  const action = yield call(parseError, error);
  if (action) {
    yield put(action);
  }
  if (error instanceof NetworkError || error instanceof RequestAbortedError) {
    // do not track known http errors
    return;
  }
  yield call(SentryService.captureException, error);
}

export default function* rootSaga(dispatch: Dispatch) {
  const sagas = [
    AppSaga,
    SubscribeSaga.default,
    AuthSaga,
    Lottie.Saga,
    LanguageSaga,
    FirebaseSaga,
    StatsSaga,
    NotificationSaga,
    CouponSaga,
    CheckoutSaga,
    ManageAppSaga,
    OrdersAppSaga,
    ExperimentsSaga,
  ];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga, dispatch);
          } catch (error) {
            yield call(handleErrorSaga, error as Error | SharedErrors.BaseError);
          }
        }
      })
    )
  );
}
